export const CAR_CATEGORIES = [
  "SUV",
  "Sedan",
  "Hatchback",
  "Pickup",
  "Van",
  "Minibus",
  "Bus",
  "Luxury",
  "4x4",
  "Other",
] as const;

export type CarCategory = (typeof CAR_CATEGORIES)[number];

export type Car = {
  _id: string;
  make: string;
  model: string;
  brand?: string;
  category?: CarCategory | string;
  year?: number | string;
  pricePerDay: number | string;
  seats?: number | string;
  transmission?: string;
  availability?: boolean;

  pickupLocation?: string;
  pickupLocationCoords?: { lat: number; lng: number };

  description?: string;
  images?: string[];
  imageUrl?: string;

  // ✅ New hire rules/policies
  minHireDays?: number;
  bufferHours?: number;
  weekendMultiplier?: number;
  longStayDiscounts?: Array<{ minDays: number; percent: number }>;
  insurancePerDay?: { none: number; basic: number; premium: number };
  depositHold?: number;
  deliveryFee?: number;
  fuelPolicy?: string;
  mileageLimitPerDay?: number;

  isMaintenance?: boolean;
  ownerId?: string;
  userId?: string;
};

export type HireAddress = { text: string; lat?: number; lng?: number };

export type QuoteBreakdown = {
  currency: string;
  basePerDay: number;
  days: number;
  baseSubtotal: number;
  weekendSurcharge: number;
  longStayDiscount: number;
  promoDiscount: number;
  insuranceFee: number;
  deliveryFee: number;
  depositHold: number;
  totalDue: number;
  totalEstimated: number;
  promoApplied?: string;
};

export type HireDraft = {
  carId: string;

  // ISO datetimes
  pickupAt: string;
  returnAt: string;

  pickupTime: string;
  returnTime: string;

  pickupAddress: HireAddress;

  deliveryRequested: boolean;
  deliveryAddress?: HireAddress;

  phoneNumber: string;
  notes?: string;

  age: number;
  acceptedTerms: boolean;

  insurancePlan: "none" | "basic" | "premium";
  promoCode?: string;

  licenseNumber?: string;
  licenseImageUrl?: string;

  damageAcknowledged?: boolean;
  beforePhotos?: string[];

  quote?: { days: number; breakdown: QuoteBreakdown; rules: any };
};

export type OrderDraft = {
  currency?: string;
  category: "delivery" | "hike" | "product" | "car_hire" | "other";
  items: Array<{
    _id: string;
    title: string;
    description?: string;
    category?: string;
    imageUrl?: string;
    price: number;
    quantity: number;
  }>;
  total: number;
  fromAddress?: string;
  deliveryInstructions?: string;

  userId: string;
  email: string;
  phoneNumber?: string;
  status?: string;
};
